interface HeaderLayoutProps {
	column1Content: React.ReactNode;
	column2Content: React.ReactNode;
	column3Content: React.ReactNode;
}

export const HeaderLayout = ({ column1Content, column2Content, column3Content }: HeaderLayoutProps) => {
	return <div className="mb-4 border-b border-gray-200 pb-4">
		<div className="grid grid-cols-2 gap-y-2 sm:grid-cols-[150px_150px_1fr]">
			<div className="text-sm">
				{column1Content}
			</div>
			<div className="text-sm">
				{column2Content}
			</div>
			<div className="text-sm col-span-2 sm:col-span-1 sm:text-right">
				{column3Content}
			</div>
		</div>
	</div>
}